import baseApi from '@/modules/services/base';
import {
  CourseLibraryTag,
  ElearningCategoriesListTag,
  TenantCategoriesTag,
  TenantProfileTag,
} from './tags';
import { PaginationParams, PaginationType } from '@/modules/types/elearning';
import {
  TenantCategoryType,
  UpdateTenantCategoryAccessResponseType,
} from '@/modules/types/tenant';

const tenantsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getElearningBehaviourSettings: build.query<any, void>({
      query: (id) => `tenant-profiles/get-elearning-behaviour-settings/`,
      providesTags: [TenantProfileTag],
    }),

    getTenantCategoryList: build.query<
      PaginationType<TenantCategoryType>,
      PaginationParams | undefined
    >({
      query: (params) => ({
        url: `tenant-profiles/category-access`,
        params,
      }),
      providesTags: [TenantCategoriesTag],
    }),

    updateTenantCategoryAccess: build.mutation<
      UpdateTenantCategoryAccessResponseType,
      TenantCategoryType
    >({
      query: (category) => ({
        url: `tenant-profiles/category-access/${category.id}`,
        method: category.is_selected ? 'POST' : 'DELETE',
      }),
      invalidatesTags: [
        TenantCategoriesTag,
        CourseLibraryTag,
        ElearningCategoriesListTag,
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetElearningBehaviourSettingsQuery,
  useGetTenantCategoryListQuery,
  useUpdateTenantCategoryAccessMutation,
} = tenantsApi;

export default tenantsApi;
